/* ==========================================================================
   Óptica Córdoba — Agenda tu examen visual
   Revelado al entrar en pantalla, acordeón de preguntas con altura animada
   y sincronía paso ↔ imagen. Sin dependencias.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__cordobaExamLoaded) return;
  window.__cordobaExamLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ------------------------------------------------------------------------
     1. REVELADO AL ENTRAR EN PANTALLA
     --------------------------------------------------------------------- */
  var pending = [];
  var watching = false;

  function revealVisible() {
    if (!pending.length) return;
    var limit = window.innerHeight * 0.92;
    pending = pending.filter(function (el) {
      if (el.getBoundingClientRect().top > limit) return true;
      el.classList.add('is-in');
      return false;
    });
    if (!pending.length) stopWatching();
  }

  function stopWatching() {
    if (!watching) return;
    watching = false;
    window.removeEventListener('scroll', revealVisible);
    window.removeEventListener('resize', revealVisible);
  }

  function initReveal(root) {
    var targets = $$('.cx-reveal, [data-cx-reveal]', root).filter(function (el) {
      return !el.classList.contains('is-in');
    });
    if (!targets.length) return;

    if (reduceMotion) {
      targets.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    pending = pending.concat(targets);

    if (!watching) {
      watching = true;
      window.addEventListener('scroll', revealVisible, { passive: true });
      window.addEventListener('resize', revealVisible);
    }

    revealVisible();
    /* Red de seguridad: si algo impidiese el cálculo inicial (fuentes, imágenes
       o una pestaña en segundo plano), volvemos a mirar al terminar la carga. */
    window.addEventListener('load', revealVisible, { once: true });
    window.setTimeout(revealVisible, 600);
  }

  /* ------------------------------------------------------------------------
     2. ACORDEÓN DE PREGUNTAS
     Anima la altura sin renunciar a <details>: el navegador conserva el
     comportamiento accesible y nosotros sólo retrasamos el cierre.
     --------------------------------------------------------------------- */
  function initFaq(list) {
    var items = $$('.cx-faq__item', list);
    var single = list.getAttribute('data-cx-faq') === 'single';

    items.forEach(function (item) {
      var summary = $('.cx-faq__summary', item);
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (item.open) {
          close(item);
          return;
        }

        if (single) {
          items.forEach(function (other) {
            if (other !== item && other.open) close(other);
          });
        }
        item.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });
    });

    /* <details> oculta su contenido en cuanto pierde `open`, así que para
       animar el cierre mantenemos el atributo y colapsamos la rejilla con
       `.is-closing`; sólo al terminar la transición cerramos de verdad. */
    function close(item) {
      var summary = $('.cx-faq__summary', item);
      var body = $('.cx-faq__body', item);

      if (summary) summary.setAttribute('aria-expanded', 'false');

      if (reduceMotion || !body) {
        item.open = false;
        return;
      }

      var finished = false;
      var finish = function () {
        if (finished) return;
        finished = true;
        body.removeEventListener('transitionend', onEnd);
        item.classList.remove('is-closing');
        item.open = false;
      };
      var onEnd = function (event) {
        if (event.target === body) finish();
      };

      item.classList.add('is-closing');
      body.addEventListener('transitionend', onEnd);
      /* Respaldo: en pestañas en segundo plano `transitionend` puede no llegar. */
      window.setTimeout(finish, 1000);
    }
  }

  /* ------------------------------------------------------------------------
     3. PASOS ↔ IMAGEN
     --------------------------------------------------------------------- */
  function initSteps(section) {
    var steps = $$('[data-cx-step]', section);
    var figures = $$('[data-cx-step-figure]', section);
    if (!steps.length) return;

    function activate(key) {
      steps.forEach(function (step) {
        step.toggleAttribute('data-active', step.getAttribute('data-cx-step') === key);
      });
      if (!figures.length) return;
      var matched = false;
      figures.forEach(function (figure) {
        var on = figure.getAttribute('data-cx-step-figure') === key;
        if (on) matched = true;
        figure.toggleAttribute('data-active', on);
      });
      if (!matched) figures[0].setAttribute('data-active', '');
    }

    steps.forEach(function (step) {
      var key = step.getAttribute('data-cx-step');
      step.addEventListener('mouseenter', function () {
        activate(key);
      });
      step.addEventListener('focusin', function () {
        activate(key);
      });
    });

    if ('IntersectionObserver' in window && !reduceMotion) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) activate(entry.target.getAttribute('data-cx-step'));
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );
      steps.forEach(function (step) {
        observer.observe(step);
      });
    }

    activate(steps[0].getAttribute('data-cx-step'));
  }

  /* ------------------------------------------------------------------------
     4. ARRANQUE
     --------------------------------------------------------------------- */
  function once(nodes, fn) {
    nodes.forEach(function (node) {
      if (node.dataset.cxReady === '1') return;
      node.dataset.cxReady = '1';
      fn(node);
    });
  }

  function boot(scope) {
    var root = scope || document;
    initReveal(root);
    once($$('[data-cx-faq]', root), initFaq);
    once($$('[data-cx-steps]', root), initSteps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
